module.exports = __webpack_public_path__ + "14d2eef6.webp";